import { Link } from "react-router-dom";
import InfoLayout from "../components/landing/InfoLayout";

const subject = "Botón de arrepentimiento - Revocar suscripción Pro";
const body = [
    "Quiero revocar la contratación del plan Pro de MiQRapp.",
    "",
    "Email de la cuenta: ",
    "Nombre de usuario del negocio: ",
    "Fecha en que me suscribí: "
].join("\n");
const mailto = `mailto:contacto@miqrapp.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

// Botón de arrepentimiento (Res. 424/2020): revocar Pro dentro de los 10 días sin iniciar sesión.
const Withdrawal = () => {
  return (
    <InfoLayout
        title="Botón de arrepentimiento - MiQRapp"
        path="/arrepentimiento"
        description="Revocá la contratación del plan Pro de MiQRapp dentro de los 10 días, sin costo."
        narrow
        eyebrow="Arrepentimiento"
        heading="Botón de arrepentimiento"
        subheading="Si te suscribiste a Pro hace 10 días o menos, podés revocar la contratación sin dar explicaciones y sin costo."
    >
        <section className="lp-section lp-info-body">
            <div className="lp-container lp-withdraw">
                <div className="lp-legal-doc">
                    <h2>Cómo hacerlo</h2>
                    <ol className="lp-withdraw-steps">
                        <li>Mandanos el pedido desde el botón de abajo o escribiendo a <strong>contacto@miqrapp.com</strong>. No hace falta iniciar sesión.</li>
                        <li>Incluí el email de tu cuenta y el nombre de usuario de tu negocio, así encontramos tu suscripción.</li>
                        <li>Dentro de las 24 horas te respondemos con un <strong>código de revocación</strong> y cancelamos la suscripción en Mercado Pago.</li>
                        <li>Si ya se había hecho algún cobro, te devolvemos el importe completo por el mismo medio de pago.</li>
                    </ol>
                    <div className="lp-withdraw-actions">
                        <a href={mailto} className="lp-btn lp-btn-primary">Revocar mi suscripción</a>
                        <a href="mailto:contacto@miqrapp.com" className="lp-text-link">contacto@miqrapp.com</a>
                    </div>
                    <p className="lp-withdraw-note">
                        Este derecho está previsto en el artículo 34 de la Ley 24.240 y en el artículo 1110 del Código Civil y Comercial.
                        Si pasaron más de 10 días, podés cancelar Pro cuando quieras desde tu cuenta para evitar cobros futuros. Más detalles en los <Link to="/terminos-y-condiciones">Términos y condiciones</Link>.
                    </p>
                </div>
            </div>
        </section>
    </InfoLayout>
  )
}

export default Withdrawal
